import { ImyDownloadBooks } from './../../models/mybook';

import { Component } from "@angular/core";
import { NavController, NavParams, ViewController, LoadingController, Platform, Events } from "ionic-angular";
import { IBook } from "../../models/book";
//import { FileTransferObject, FileTransfer } from "@ionic-native/file-transfer";
//import { File } from "@ionic-native/file";
import { FirebaseService } from "../../services/firebase.service";


@Component({
  selector: "page-book-detail",
  templateUrl: "book-detail.html"
})
export class BookDetailPage {
  loading: any;
  book: IBook;
  userid: string;
  isPresent: boolean = false;
  isOpenDetail: boolean = false;

  //private fileTransfer: FileTransferObject;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private loadinCtrl: LoadingController,
    public eventCtrl: Events,
    private FireSrvc: FirebaseService,
    public platform: Platform,
    //public transfer: FileTransfer,
   // public file: File
    ) {
    this.book = navParams.get("book");
    this.userid = navParams.get("iduser");
    this.isPresent = navParams.get("present");
  }

  //Aggiungi libro
  AddtoMyBook(book: IBook) {
    this.PresentLoading();

    let ePubLocal: string = "";
    

    //Scrive nel Database
    this.FireSrvc.AddMyBook(book, ePubLocal, book.imgurl);

    //Carica le info dei libri locali
    let UserDowloadBooks: ImyDownloadBooks[];
    let MyBookLocal: ImyDownloadBooks = {
      id: book.id,
     status: 'Online',
     ePubLocal: '',
     imgLocal: ''
    };

    // debugger;

    // Aggiunta libro nell'arry locale
    //Carica i dati dell'utente e i libri nella proprio libreria locali
    if (localStorage.getItem("UserDowloadBooks")) {
      UserDowloadBooks = JSON.parse(localStorage.getItem("UserDowloadBooks"));
      UserDowloadBooks.push(MyBookLocal);

    }else{
      // Aggiunge il libro all'array
      UserDowloadBooks = [MyBookLocal];
    }

    //Salvo nella localStorage
    localStorage.setItem("UserDowloadBooks", JSON.stringify(UserDowloadBooks));

    //#1.0.2 - aggiunto evento per resettare il filtro di ricerca
    this.eventCtrl.publish('addBook:ok');

    this.loading.dismiss();
    this.viewCtrl.dismiss();
    this.navCtrl.parent.select(0);



  }

  /*
  //Aggiungi libro
  AddtoMyBookLocal(book: IBook) {


    let ePubLocal: string;
    let imgLocal: string;

    // Scarica il file nella memoria locale
    let myfile = new MyFileClass(this.platform);

    this.PresentLoading();

    // Scarica il file ePub
    myfile.SaveLocalFile(book.ePubUrl, book.id + ".epub")
      .then(resePub => {

        ePubLocal = resePub;

        // Scarica il file ePub
        // this.SaveLocalFile(book.imgurl, book.id + ".jpg")
        //   .then(resImg => {

        //     imgLocal = resImg;

        console.log("ePubLocal -> " + ePubLocal);
        // console.log("imgLocal -> " + imgLocal);

        //Scrive nel Database
        this.FireSrvc.AddMyBook(book, ePubLocal, book.imgurl);

        this.viewCtrl.dismiss();
        this.navCtrl.parent.select(0);

        // })
        // .catch(err => {
        //   console.error(err);
        //   alert(err);
        // });

      })
      .catch(err => {
        console.error(err);
        alert(err);
      });

    this.loading.dismiss();
  }

  */

  //Mostra lo spin di caricamento
  PresentLoading() {
    this.loading = this.loadinCtrl.create({
      spinner: "ios",
      content: "Attendere..."
      // dismissOnPageChange : true
    });

    this.loading.present();
  }

  toggleSelection() {
    this.isOpenDetail = !this.isOpenDetail;
  }

}



// WEBPACK FOOTER //
// ./src/pages/book-detail/book-detail.ts